<template>
  <div class="limiter" v-if="id">
    <div class="image">
      <img src="../assets/logo/logo.png" alt="Logo">
    </div>
    <div class="container-login100 d-block">

      <h2 style="color: #3A6898">Stock Details</h2>

      <div class="wrap-login100 " v-for="item in items">
        <div class="form-summary" >
          <div class="form-group">
            <p class="summary-item"><strong>invoiceNumber: </strong>{{ item.invoiceNumber }}</p>
          </div>
          <div class="form-group">
            <p class="summary-item"><strong>Description: </strong>{{item.Description}}</p>
          </div>
          <div class="form-group">
            <p class="summary-item"><strong>deliveryQty: </strong>{{item.deliveryQty}} </p>
          </div>
          <div class="form-group">
            <p class="summary-item"><strong>PLU: </strong>{{item.PLU}} </p>
          </div>
        </div>
      </div>

      <button class="login100-form-btn" @click="logout" >
        Logout
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      id: this.$route.query.id,
      headerId: this.$route.query.headerId,
      items : []
    }
  },
  watch: {
    '$route.query.id': function (newId) {
      this.id = newId;
    },
  },
  async beforeMount() {
    this.showStock()
  },
  methods:{
    showStock(){
      this.$store.commit(`setLoadingState`, true);
      const payload = {
        id: this.id,
        urlId: this.$route.query.urlId
      }
      return this.$store.dispatch('showStock',payload)
          .then(response => this.items = response)
          .finally(()=> this.$store.commit(`setLoadingState`, false))
    },
    logout() {
      localStorage.removeItem('user');
      this.$router.push(`/login?id=${this.id}`);
    },
  }
}
</script>

<style>
.wrap-login100 {
  margin-bottom: 20px;
}
</style>